<script lang="ts">
  import AlertsDialog from './dialogs/AlertsDialog.svelte';
  import CommandPalette from './dialogs/CommandPalette.svelte';
  import EditTimesDialog from './dialogs/EditTimesDialog.svelte';
  import HelpDialog from './dialogs/HelpDialog.svelte';
  import RunSheet from './dialogs/RunSheet.svelte';
  import SetElapsedDialog from './dialogs/SetElapsedDialog.svelte';
  import NewVersionPill from './NewVersionPill.svelte';
  import OfflineBanner from './OfflineBanner.svelte';
  import ConfirmDialog from './ui/ConfirmDialog.svelte';
</script>

<RunSheet />
<EditTimesDialog />
<SetElapsedDialog />
<CommandPalette />
<HelpDialog />
<AlertsDialog />
<ConfirmDialog />
<NewVersionPill />
<OfflineBanner />
